import React, { useRef, useEffect, useContext } from "react";
import axios from "axios";
import { webSocketManager } from "../../Sockets/WebSocketManager";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formattedEmail } from "../Helpers/Email/Email";
import { popupcontext } from "../../context/Popupscontext";
import { languagecontext } from "../../context/LanguageContext";
import trans from "../../utils";
import { filtrationcontext } from "../../context/Filtercontext";
import AES from "crypto-js/aes";
import CryptoJs from "crypto-js";
import { setOfflineMode } from "../../Redux/service/Users/UsersSlice";
export default function HeaderDropdown() {
	let navigate = useNavigate();
	let inf = useSelector((state) => state.users.user);
	let { setOptions } = useContext(popupcontext);
	let { setLoader } = useContext(filtrationcontext);
	let { setLang, setReRender, lang } = useContext(languagecontext);
	const dropdownRef = useRef(null);
	const signingOutRef = useRef(false); // Ref to track if sign-out is in progress
	const dispatch = useDispatch();
	const handleLogout = async () => {
		signingOutRef.current = true;

		try {
			const res = await axios.delete(
				`${process.env.REACT_APP_AUTH_APIS_URL}/users/logout`,
				{ withCredentials: true },
			);

			if (res.status >= 200 && res.status < 300) {
				webSocketManager.disconnect();
				dispatch(setOfflineMode(false));

				localStorage.removeItem("token");
				localStorage.removeItem("user");
				localStorage.removeItem("persist:root");

				sessionStorage.clear();
				delete axios.defaults.headers.common["Authorization"];
				window.location.replace(`${process.env.PUBLIC_URL}/signin`);
			}
		} catch (error) {
			console.warn("Logout failed, storage not cleared:", error);
		} finally {
			setOptions(false);
			signingOutRef.current = false;
		}
	};

	// Close dropdown when clicking outside, but ignore if sign-out is in progress
	const handleClickOutside = (event) => {
		if (
			dropdownRef.current &&
			!dropdownRef.current.contains(event.target) &&
			!signingOutRef.current
		) {
			setOptions(false);
		}
	};

	useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const switchLanguage = (lang) => {
		const currentLang = localStorage.getItem("lang");
		if (currentLang === lang) return;
		setLoader(true);
		let newLang;

		if (currentLang) {
			// If same, keep the same
			if (currentLang === lang) {
				newLang = currentLang;
			} else {
				// Switch to the requested one
				newLang = lang;
			}
		} else {
			// No language set yet, use the requested one
			newLang = lang;
		}

		setLang(newLang);
		localStorage.setItem("lang", newLang);
		document.body.dir = newLang === "ar" ? "rtl" : "ltr";

		// Reload after setting everything
		window.location.reload();
	};

	return (
		<div
			className={`header-dropdown ${
				localStorage.getItem("lang") !== "ar"
					? "header-dropdown-ltr"
					: "header-dropdown-rtl"
			}`}
			dir={localStorage.getItem("lang") !== "ar" ? "ltr" : "rtl"}
			ref={dropdownRef}
		>
			<div className="header-dropdown-inf">
				<img
					src={`${process.env.PUBLIC_URL}/assets/New/Randoms/Avatar.svg`}
					alt="logo"
					width={40}
					className={`${
						localStorage.getItem("lang") !== "ar" ? "me-3" : "ms-3"
					}`}
				/>
				<div
					className="d-flex flex-column"
					style={{ transform: "translateY(-7px)" }}
				>
					<div
						className="header-dropdown-inf-name"
						style={{ lineHeight: "32px" }}
					>
						{inf?.name}
					</div>
					<div className="header-dropdown-inf-email">
						{formattedEmail(inf?.email)}
					</div>
				</div>
			</div>

			<div className="header-dropdown-options">
				<div className="flex-between px-1 py-3 m-0">
					<div className="flex-between">
						<img
							src={`${process.env.PUBLIC_URL}/assets/New/Randoms/Language.svg`}
							alt="lang"
							className={`${
								localStorage.getItem("lang") === "ar" ? "ms-2" : "me-2"
							}`}
						/>
						<div>{trans("Language")}</div>
					</div>
					<div className="multi-language">
						<div
							onClick={() => switchLanguage("ar")}
							className={`${
								localStorage.getItem("lang") === "ar"
									? "multi-language-active"
									: "multi-language-value"
							}`}
						>
							<div>Ar</div>
						</div>
						<div
							onClick={() => switchLanguage("en")}
							className={`${
								localStorage.getItem("lang") === "en" ||
								localStorage.getItem("lang") === null
									? "multi-language-active"
									: "multi-language-value"
							}`}
						>
							<div>En</div>
						</div>
					</div>
				</div>
				<div className="px-1 py-3" onClick={() => navigate("/setup/account")}>
					<div className="d-flex align-items-center">
						<img
							src={`${process.env.PUBLIC_URL}/assets/New/Randoms/Settings.svg`}
							alt="lang"
							className="me-2"
						/>
						<div>{trans("Settings")}</div>
					</div>
				</div>{" "}
				<div className=" px-1 py-3" onClick={handleLogout}>
					<div className="d-flex align-items-center">
						<img
							src={`${process.env.PUBLIC_URL}/assets/New/Randoms/Logout.svg`}
							alt="lang"
							className="me-2"
						/>
						<div>{trans("sign out")}</div>
					</div>
				</div>{" "}
				{/* Updated logout handling */}
			</div>
		</div>
	);
}
